import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Hidden from '@material-ui/core/Hidden';
import StickerIcon from '@material-ui/icons/CropFree';
import LogoutIcon from '@material-ui/icons/Lock';
import DashboardIcon from '@material-ui/icons/Dashboard';
import StorageIcon from '@material-ui/icons/Storage';
import PeopleIcon from '@material-ui/icons/People';
import PrinterIcon from '@material-ui/icons/Print';
import DevicesIcon from '@material-ui/icons/Devices';
import MapIcon from '@material-ui/icons/Map';
import LawIcon from '@material-ui/icons/Gavel';
import {Auth} from 'aws-amplify';
import environment from '../environments';
import Logo from "../assets/img/logo-line-on-black.svg";

import Main from './Main';
import ApiProgress from './shared/ApiProgress';
import {NavLink} from 'react-router-dom';

const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        marginLeft: drawerWidth,
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    menuButton: {
        marginRight: 20,
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    }
});

class Navigation extends Component
{
    state = {
        mobileOpen: false,
    };

    handleDrawerToggle = () =>
    {
        this.setState(state => ({mobileOpen: !state.mobileOpen}));
    };

    handleCloseOnClick = () =>
    {
        this.setState(state => ({mobileOpen: false}));
    }

    login()
    {
        //console.log("Login pressed");
    }

    logout()
    {
        Auth.signOut()
            .then(() =>
            {
                this.props.screenProps.onStateChange('signedOut', null);
            })
            .catch((error) =>
            {
                return error;
            })
    }

    render()
    {
        const {classes, theme} = this.props;

        const drawer = (
            <div>
                <div className={classes.toolbar} style={{background: '#212121'}}/>
                <Divider/>
                <List>
                    <ListItem button component={NavLink} to="/dashboard" activeClassName="active">
                        <ListItemIcon>
                            <DashboardIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Dashboard"/>
                    </ListItem>
                    <ListItem button component={NavLink} to="/products">
                        <ListItemIcon>
                            <StorageIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Produkte"/>
                    </ListItem>
                    <ListItem button component={NavLink} to="/clients">
                        <ListItemIcon>
                            <PeopleIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Kunden"/>
                    </ListItem>
                    <ListItem button component={NavLink} to="/orders">
                        <ListItemIcon>
                            <PrinterIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Druckaufträge"/>
                    </ListItem>
                    <ListItem button component={NavLink} to="/stickers">
                        <ListItemIcon>
                            <StickerIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Sticker"/>
                    </ListItem>
                    <ListItem button component={NavLink} to="/users">
                        <ListItemIcon>
                            <DevicesIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Benutzer"/>
                    </ListItem>
                    <ListItem button component={NavLink} to="/terms">
                        <ListItemIcon>
                            <LawIcon/>
                        </ListItemIcon>
                        <ListItemText primary="AGB &amp; Datenschutz"/>
                    </ListItem>
                    <ListItem button component={NavLink} to="/map">
                        <ListItemIcon>
                            <MapIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Karte"/>
                    </ListItem>
                </List>
                <Divider/>
                <List>
                    <ListItem button onClick={this.logout.bind(this)}>
                        <ListItemIcon>
                            <LogoutIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Logout"/>
                    </ListItem>
                </List>
                <Divider/>
                <Typography variant="body2" align="center"
                            style={{padding: '8px', color: 'rgba(0, 0, 0, 0.12)', fontSize: "12px"}}>
                    "QR Code" ist eine eingetragene Marke der DENSO WAVE INCORPORATED in Japan und anderen Ländern.
                </Typography>
                <Typography variant="body2" align="center"
                            style={{paddingTop: '8px', color: 'rgba(0, 0, 0, 0.12)', fontSize: "12px"}}>
                    Version: {process.env.REACT_APP_VERSION}
                </Typography>
            </div>
        );

        return (
            <div className={classes.root}>
                <CssBaseline/>
                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.handleDrawerToggle}
                            className={classes.menuButton}>
                            <MenuIcon/>
                        </IconButton>
                        <Typography variant="subheading" color="inherit" noWrap className={classes.grow}>
                            <img src={Logo} height="20"
                                 alt="QRSticker logo"/>&nbsp;&nbsp;{environment.TITLE}
                        </Typography>
                    </Toolbar>
                    <ApiProgress/>
                </AppBar>
                <nav className={classes.drawer}>
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Hidden smUp implementation="css">
                        <Drawer
                            container={this.props.container}
                            variant="temporary"
                            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                            open={this.state.mobileOpen}
                            onClose={this.handleDrawerToggle}
                            classes={{
                                paper: classes.drawerPaper,
                            }}>
                            {drawer}
                        </Drawer>
                    </Hidden>
                    <Hidden xsDown implementation="css">
                        <Drawer
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            variant="permanent"
                            open>
                            {drawer}
                        </Drawer>
                    </Hidden>
                </nav>
                <main className={classes.content}>
                    <Main/>
                </main>
            </div>
        );
    }
}

Navigation.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(Navigation);
